import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-default',
  standalone: false,
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss']
})
export class DefaultFooterComponent {}
